<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <full-calendar :options="calendarOptions" ref="fullCalendar"></full-calendar>
    </b-col>
  </b-row>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import pl from '@fullcalendar/core/locales/pl'
import getId from '@/utils/getIdFromLink'
import Loader from '../../../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import VueCookie from 'vue-cookie'

export default {
  name: 'DailyPlanServicemanCalendar',
  components: {
    Loader,
    FullCalendar
  },
  data () {
    return {
      isLoading: true,
      firstInit: true,
      dailyPlanItems: [],
      dateFrom: '',
      dateTo: '',
      calendarOptions: {
        contentHeight: 700,
        locale: pl,
        plugins: [ dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridMonth',
        dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        events: []
      }
    }
  },
  created () {
    this.getDailyPlanItems()
  },

  computed: {
    idServiceman () {
      return parseInt(this.getIdLink(this.$route.params.idServiceman))
    }
  },

  methods: {
    async handleEventClick (calendarObject) {
      let eventId = calendarObject.event._def.publicId
      console.log(eventId)
      if (eventId.includes('e_x_c_m_tasks')) {
        let decision = await this.promptUser(this.$t('global.goToTask'))
        if (decision) {
          this.$router.push({ name: 'EXCMTaskShow', params: { id: eventId } })
        }
      }
    },
    async handleDateClick (date) {
      let decision = await this.promptUser(this.$t('global.goToDailyPlan'))
      if (decision) {
        this.$router.push({
          name: 'DailyPlanShow',
          params: {
            idServiceman: this.idServiceman,
            date: date.dateStr
          }
        })
      }
    },
    promptUser (title) {
      return this.$Swal({
        title: title,
        showCancelButton: true,
        confirmButtonText: this.$t('global.yes'),
        cancelButtonText: this.$t('global.no')
      })
    },
    async getDailyPlanItems () {
      let params = {
        'idUserData': this.idServiceman,
        'pagination': false
      }
      let url = addParamsToQuery('e_x_c_m_daily_plan_items', params)
      const response = await new ApiService(url).getResults()
      let data = response.items
      for (let i in data) {
        let element = {}
        let taskType = data[i].task.idTaskType.title
        let servicemanName = data[i].idUserData.name + ' ' + data[i].idUserData.surname
        let contractorName = ''
        if (data[i].task.idCase.contractorUserData) {
          contractorName += data[i].task.idCase.contractorUserData.firmname1
        }
        let status = ''
        let caseNumberText = data[i].task.idCase.number ? data[i].task.idCase.number : this.getIdLink(data[i].task.idCase['@id'])
        if (data[i].task.finished === 1) { // Zakończone zadania nie pojawią się na kalendarzu
          continue
        } else if (data[i].status === 1 && !(data[i].dateStart) && !(data[i].dateStop)) {
          status = this.$t('views.excmtask.show.dailyPlanItemStatuses.notOver')
        } else if (data[i].status === 1 && data[i].dateStart && !(data[i].dateStop)) {
          status = this.$t('global.processing')
        } else if (data[i].status === 1 && data[i].dateStart && data[i].dateStop) {
          status = this.$t('global.over')
        } else if (data[i].status === 0 && data[i].dateStart && data[i].dateStop) {
          status = this.$t('global.held')
        } else if ((data[i].status === 2) && data[i].dateStart) {
          continue
        } else if ((data[i].status === 2) && !(data[i].dateStart)) {
          continue
        } else if ((data[i].status === 3) && data[i].dateStart) {
          status = this.$t('global.movedToMainStarted')
        } else if ((data[i].status === 3) && !(data[i].dateStart)) {
          status = this.$t('global.movedToMainNotStarted')
        }
        element.title = '\n' + caseNumberText + ' /' + '\n' + taskType + '\n' + status + '\n' + servicemanName + '\n' + contractorName
        if (data[i].dateStart) {
          element.start = this.$moment(data[i].dateStart).format('YYYY-MM-DD HH:mm:ss')
        } else {
          element.start = this.$moment(data[i].date).format('YYYY-MM-DD')
        }
        if (data[i].dateStop) {
          element.end = this.$moment(data[i].dateStop).format('YYYY-MM-DD HH:mm:ss')
        } else {
          element.end = this.$moment(data[i].date).format('YYYY-MM-DD')
        }
        if (!data[i].dateStart && !data[i].dateStop && data[i].timeStartOnCalendar) {
          element.start = this.$moment(data[i].date).format('YYYY-MM-DD') + ' ' + this.$moment(data[i].timeStartOnCalendar).format('HH:mm:ss')
          // 60 minut później
          element.end = this.$moment(element.start).add(60, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
        if (data[i].task.idTaskType.color) {
          element.color = data[i].task.idTaskType.color
          element.textColor = '#000000'
        } else if (data[i].status === 0) {
          element.color = '#FF0000'
          element.textColor = '#000000'
        } else if (data[i].status === 1) {
          element.color = '#168225'
          element.textColor = '#000000'
        } else if (data[i].status === 2 || data[i].status === 3) {
          element.color = '#f5e400'
          element.textColor = '#000000'
        }
        element.id = data[i].task['@id']
        element.customOrdering = data[i].customOrdering
        this.calendarOptions.events.push(element)
      }
      this.isLoading = false
      let calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.render()
    },
    getIdLink (link) {
      if (link === '/api/user_datas/null') {
        link = VueCookie.get('user_data_id')
      }
      return getId(link)
    }
  }
}
</script>
